'use strict';

var EditIntrusionDetection = require('actionGroups/intrusionDetection/IntrusionDetection');

module.exports = {
  Model: EditIntrusionDetection,
};
